import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * UX-02 — a legacy report URL still works: this renders nothing, rewrites
 * the query string via `transform`, and lands on `to` with `replace` so the
 * browser back button doesn't bounce back to the dead route.
 */
export const RedirectWithParams: React.FC<{
  to: string;
  transform: (params: URLSearchParams) => URLSearchParams;
}> = ({ to, transform }) => {
  const location = useLocation();
  const nextParams = transform(new URLSearchParams(location.search));
  const search = nextParams.toString();
  return <Navigate to={search ? `${to}?${search}` : to} replace />;
};

export default RedirectWithParams;
